// Export the Component Definition for use in Contentful Studio
export {AFEEligibilityContentfulComponentDefinition} from './AFEEligibilityContentfulDefinition';
export {default} from './AFEEligibility';
